import React, { useState } from "react"
// reactstrap components
import { Card, CardHeader, CardBody, Container, Row, Col, Button, Input, Media, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { TextInput } from "react-native-web";
// core components
import Header from "../../../components/headers/Header";
import MessageBox from "../../../components/ui/MessageBox";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/homework/UnitPreviewRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";
import "antd/dist/antd.css";
import * as Helper from "../../../utils/Helper";
import * as UnitHelper from "../../../utils/UnitHelper";
import EllipsisText from "../../../components/ui/EllipsisText";
import Word from "../../../components/ui/Word";
import { GetCountOfMarkTypeFromSentence } from "../../../utils/MarkTextHelper";
import Constants from "../../../config/Constants";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import CollapseImg from "../../../components/ui/CollapseImg";
import CollapseUnitView from "../../../components/ui/CollapseUnitView";
import { confirmAlert } from "react-confirm-alert";
import UnitView from "../../../components/units/UnitView";
import _ from 'lodash';

const uid = UIDs.screens.admin.homework.unitpreview;

class UnitPreviewScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_REFERENCE_ANSWER_ASYNC]: { done: this._handleSaveReferenceAnswerDone, error: this._handleAsyncActionError },
            [ActionTypes.REPORT_ERROR_ASYNC]: { done: this._handleReportErrorDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            errorText: '',
        };

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        this.props.loadScreenViewAsync({partnerId: (this.props.partner ? this.props.partner.id : null)}, this.props.unit);
    }

    _handleAsyncActionError = action => {
        this.displayError(action.error);
    };

    _handleSaveReferenceAnswerDone = action => {
        MessageBox.success({ text: this.props.t("saveSuccess"), duration: 5000 });
        if (this.props.onClose) {
            this.props.onClose();
        } else {
            this.props.viewUnitAnswer(null);
        }
    }

    _handleCloseReportError() {
        this.setState({errorText: ''});
        this.props.showReportError(false);
    }

    _handleCheckAnswer = () =>{
        const unitData = this._unitView ? this._unitView.getUnitData() : {};
        const { referenceAnswers = [] } = unitData;
        if (unitData && unitData.units) {
            // 复合单元，特殊处理
            for (let i = 0; i < unitData.units.length; ++i) {
                let subUnitData = JSON.parse(unitData.units[i].data);
                referenceAnswers[i] = subUnitData.referenceAnswers;

                let hasNoError = true;
                _.each(referenceAnswers[i], (answer) => {
                    if (Helper.isNullOrEmpty(answer.text)) {
                        hasNoError = false;
                    }
                });

                if (!hasNoError) {
                    MessageBox.danger(this.props.t("hasEmptyAnswer"));
                    return false;
                }
            }
            return true;
        }

        if ((!referenceAnswers) || (referenceAnswers.length === 0)) {
            MessageBox.danger(this.props.t("hasEmptyAnswer"));
            return false;
        } else {
            let hasNoError = true;
            _.each(referenceAnswers, (answer) => {
                if (Helper.isNullOrEmpty(answer.text)) {
                    hasNoError = false;
                }
            });

            if (!hasNoError) {
                MessageBox.danger(this.props.t("hasEmptyAnswer"));
            }
            return hasNoError;
        }
    }

    _setupUnit = (r) => {
        this._unitView = r;
    };

    _handleSaveReferenceAnswer() {
        if(this._handleCheckAnswer()){
            const { viewUnitAnswer } = this.props.localState;
            const unitData = this._unitView ? this._unitView.getUnitData() : {};
            const { referenceAnswers = [] } = unitData;
            if (unitData && unitData.units) {
                // 复合单元，特殊处理
                for (let i = 0; i < unitData.units.length; ++i) {
                    let subUnitData = JSON.parse(unitData.units[i].data);
                    referenceAnswers[i] = subUnitData.referenceAnswers;
                }
            }

            const referenceAnswersData = JSON.stringify(referenceAnswers);
            this.props.saveReferenceAnswerAsync({id: viewUnitAnswer.id,
                                                 partnerId: (this.props.partner ? this.props.partner.id : null),
                                                 unitType: viewUnitAnswer.unitType,
                                                 referenceAnswers: referenceAnswersData});
        }
    }

    renderEditUnitAnswerModal() {
        // TODO
        return null;
    }

    renderViewUnitAnswerModal() {
        const { viewUnitAnswer, showReportError } = this.props.localState;
        let hasUnitAnswer = true;
        let hasReferenceAnswer = false;
        if (viewUnitAnswer) {
            const unit = viewUnitAnswer;
            const unitData = JSON.parse(unit.data);
            if (unit.isSubjective) {
                hasReferenceAnswer = UnitHelper.hasReferenceAnswer(unitData);
                hasUnitAnswer = !!hasReferenceAnswer;
                const noRefAnswerUnits = ["PSKA5", "PSDO1", "PSSD1"];
                if (noRefAnswerUnits.indexOf(unit.unitType) >= 0) {
                    hasUnitAnswer = true;
                }
            }
        }

        const editAnswer = (!hasUnitAnswer);
        return (
            <Modal isOpen={viewUnitAnswer ? true : false}>
                <ModalHeader className="aic-modal-header" toggle={() => {
                                 this._handleCloseReportError();
                                 if (this.props.onClose) {
                                     this.props.onClose();
                                 } else {
                                     this.props.viewUnitAnswer(null);
                                 }
                             }} charCode="X"><h3>{this.props.t("mobilePreview")}</h3></ModalHeader>
                <ModalBody>
                    <div style={{position: 'relative'}}>
                        <div style={{ margin: "0 auto", width: "412px", border: "solid 0px #ccc", padding: "6px" }}>
                            {viewUnitAnswer ?
                             (<UnitView
                                  ref={this._setupUnit}
                                  mode={2}
                                  showAnswer={true}
                                  editAnswer={editAnswer}
                                  unitType={viewUnitAnswer.unitType}
                                  cover={viewUnitAnswer.cover}
                                  data={JSON.parse(viewUnitAnswer.data)}
                                  result={null}
                                  width={400}
                                  height={720}
                              />): null}
                        </div>
                        {this.isActionExecuting(ActionTypes.SAVE_REFERENCE_ANSWER_ASYNC) ?
                         (<div style={{zIndex: 1, position: 'absolute', display: 'flex',
                                       alignItems: 'center', justifyContent: 'center',
                                       left: 0, top: 0, right: 0, bottom: 0, }}>
                              <LoadingIndicator />
                          </div>) : null}
                    </div>
                </ModalBody>
                <div style={{ height: 1, backgroundColor: '#e9ecef' }}/>
                <ModalFooter>
                    {editAnswer ?
                     (<Button className='btn-info' onClick={() => {
                                  this._handleSaveReferenceAnswer();
                              }}>{this.props.t("save")}</Button>) :
                     (<Button className='btn-warning' onClick={() => {
                                  this.props.showReportError(true)
                              }}>{this.props.t("reportError")}</Button>)}
                    <Button className='btn-default' onClick={() => {
                                this._handleCloseReportError();
                                if (this.props.onClose) {
                                    this.props.onClose();
                                } else {
                                    this.props.viewUnitAnswer(null);
                                }
                            }}>{this.props.t("close")}</Button>
                </ModalFooter>
            </Modal>);
    }

    renderReportErrorModal() {
        const { viewUnitAnswer, showReportError } = this.props.localState;
        return (
            <Modal isOpen={showReportError ? true : false}>
                <ModalHeader className="aic-modal-header" toggle={() => {
                                 this._handleCloseReportError();
                             }} charCode="X"><h3>{this.props.t("reportError")}</h3></ModalHeader>
                <ModalBody>
                    <div style={{position: 'relative'}}>
                        <div style={{display: 'flex', flexDirection: 'column', height: 240,
                                     borderWidth: 1, borderColor: '#e9ecef', borderStyle: 'solid',
                                     borderRadius: 8, padding: 8}}>
                            <TextInput
                                style={{flex: 1}}
                                onChangeText={text => this.setState({errorText: text})}
                                placeholder={this.props.t("errorDesc")}
                                placeholderTextColor='#a5a5a5'
                                multiline={true}
                                autoFocus={true}
                                value={this.state.errorText}
                            />
                        </div>
                        {this.isActionExecuting(ActionTypes.REPORT_ERROR_ASYNC) ?
                         (<div style={{zIndex: 1, position: 'absolute', display: 'flex',
                                       alignItems: 'center', justifyContent: 'center',
                                       left: 0, top: 0, right: 0, bottom: 0, }}>
                              <LoadingIndicator />
                          </div>) : null}
                    </div>
                </ModalBody>
                <div style={{ height: 1, backgroundColor: '#e9ecef' }}/>
                <ModalFooter>
                    <Button color="primary" onClick={() => {
                                const text = this.state.errorText.trim();
                                if (!text) {
                                    MessageBox.danger({ text: this.props.t("pleaseInputErrorDesc"), duration: 5000 });
                                    return
                                }

                                this.props.reportErrorAsync({id: viewUnitAnswer.id, description: text});
                            }}>{this.props.t("send")}</Button>
                    <Button className='btn-default' onClick={() => {
                                this._handleCloseReportError();
                            }}>{this.props.t("close")}</Button>
                </ModalFooter>
            </Modal>);
    }

    render() {
        return (
            <>
                {this.renderEditUnitAnswerModal()}
                {this.renderViewUnitAnswerModal()}
                {this.renderReportErrorModal()}
            </>
        );
    }

    _handleReportErrorDone = action => {
        MessageBox.success({ text: this.props.t("reportSuccess"), duration: 5000 });
        this._handleCloseReportError();
    }
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partner: state.session.partner
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (vo, unit) => dispatch(Actions.loadScreenViewAsync(vo, unit)),
        editUnitAnswer: (id) => dispatch(Actions.editUnitAnswer(id)),
        viewUnitAnswer: (id) => dispatch(Actions.viewUnitAnswer(id)),
        showReportError: (show) => dispatch(Actions.showReportError(show)),
        saveReferenceAnswerAsync: (vo) => dispatch(Actions.saveReferenceAnswerAsync(vo)),
        reportErrorAsync: (vo) => dispatch(Actions.reportErrorAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(UnitPreviewScreen));
